// File generated by create-react-app on 25-03-2024.

import React, {type ReactElement} from 'react';

import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './output.css';
import {TaskManagementSystem} from './modules/TaskManagementSystem';

/**
 *
 * @author Reginald Sahil Chand
 * @email Developer.ReginaldSahilChand@gmail.com
 *
 * @description Entry point for the Task Quazar application.
 * @version 0.1.0
 *
 * @returns {JSX Element} - JavaScript (HTML) element.
 */
export const App: React.FC = (): ReactElement => {
	return (
		<>
			<ToastContainer
				position="top-right"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="dark"
			/>
			<TaskManagementSystem />
		</>
	);
};
